<div>
	<form [formGroup]="form" (ngSubmit)="onSubmit()">
		<app-field-label>Submit Emails</app-field-label>
		<p>Format: email, first name, last name (one per line, first / last name are optional)</p>
		<p>example: john.doe&commat;example.com, John, Doe</p>

		<br />

		<app-textarea-field
			[fg]="form"
			formGroupOrControlName="emails"
			label="Emails"
			placeholder="One email per line..."
		></app-textarea-field>

		<app-form-submit-button [disabled]="!form.valid">Preview</app-form-submit-button>
	</form>
</div>
